"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _big = _interopRequireDefault(require("big.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
_big["default"].DP = 3;
var _default = exports["default"] = _big["default"];